import { Navigate } from "react-router-dom";

// Dashboard
import Dashboard from "../pages/Custom-Dashboard/index";
import RoleList from "../pages/Masters/Roles/RoleList";
import RoleCreate from "../pages/Masters/Roles/RoleCreate";
import UserList from "../pages/Masters/Users/userList";
import UserCreate from "../pages/Masters/Users/UserCreate";
import StateList from "../pages/Masters/States/StateList";
import StateCreate from "../pages/Masters/States/StateCreate";
import CityList from "../pages/Masters/Cities/CityList";
import CityCreate from "../pages/Masters/Cities/CityCreate";
import UOMCreate from "../pages/Masters/UOM/UOMCreate";
import UOMList from "../pages/Masters/UOM/UOMList";
import CategoryCreate from "../pages/Masters/Categories/CategoryCreate";
import CategoryList from "../pages/Masters/Categories/CategoryList";
import MenuList from "../pages/Masters/Menu/MenuList";
import MenuCreate from "../pages/Masters/Menu/MenuCreate";
import WarehouseList from "../pages/Masters/Warehouses/WarehouseList";
import WarehouseCreate from "../pages/Masters/Warehouses/WarehouseCreate";
import ItemCreate from "../pages/Masters/Items/ItemCreate";
import ItemList from "../pages/Masters/Items/ItemList";
import BOMList from "../pages/Masters/Boms/BOMList";
import BOMCreate from "../pages/Masters/Boms/BOMCreate";
import StageCreate from "../pages/Masters/Stages/StageCreate";
import StageList from "../pages/Masters/Stages/StageList";

//project
import ProjectList from "../pages/Project-Management/ProjectList";
import ProjectView from "../pages/Project-Management/ProjectView";
import ProjectCreate from "../pages/Project-Management/ProjectCreate";

//order
import OrderList from "../pages/Order-Management/OrderList";
import OrderCreate from "./../pages/Order-Management/OrderCreate";
import OrderView from "./../pages/Order-Management/OrderView";

//invoice
import InvoiceCreate from "../pages/Invoice-Management/InvoiceCreate";
import InvoiceView from "../pages/Invoice-Management/InvoiceView";
import InvoicetList from "../pages/Invoice-Management/InvoiceList";

// Access routes
import ProjectAccess from "../pages/Access/ProjectAccess/ProjectAccess";
import UserTypeAccess from "../pages/Access/UserTypeAccess/UserTypeAccess";
import UserMenuAccess from "../pages/Access/UserMenuAccess/UserMenuAccess";
import CommissioningList from "../pages/Masters/Commissioning/CommissioningList";
import CommissioningCreate from "../pages/Masters/Commissioning/CommissioningCreate";
import InstallationCreate from "../pages/Masters/Installations/InstallationCreate";
import InstallationList from "../pages/Masters/Installations/InstallationList";
import InwardList from "../pages/Inward-Management/InwardList";
import InwardCreate from "../pages/Inward-Management/InwardCreate";
import InwardView from "../pages/Inward-Management/InwardView";
import OutwardList from "./../pages/Outward-Management/OutwardList";
import OutwardCreate from "./../pages/Outward-Management/OutwardCreate";
import OutwardView from "./../pages/Outward-Management/OutwardView";
import ViewStocks from "../pages/Reports/ViewStocks";
import SubcontractorAndCustomerList from "../pages/Masters/Subcontractor&Customer/SubcontractorAndCustomerList";
import SubcontractorAndCustomerCreate from "../pages/Masters/Subcontractor&Customer/SubcontractorAndCustomerCreate";
import OrderTracking from "../pages/Reports/OrderTracking";
import GSTPercentageCreate from "../pages/Masters/GSTPercentage/GSTPercentageCreate";
import GSTPercentageList from "../pages/Masters/GSTPercentage/GSTPercentageList";
import ReturnInwardList from "../pages/Return-Inward-Management/ReturnInwardList";
import ReturnInwardCreate from "../pages/Return-Inward-Management/ReturnInwardCreate";
import ReturnInwardView from "../pages/Return-Inward-Management/ReturnInwardView";
import ScrabApprovalList from "../pages/Scrab-Approval/ScrabApprovalList";
import ScrabApprovalView from "../pages/Scrab-Approval/ScrabApprovalView";
import InstallationListView from "../pages/Installation-List/InstallationListView";
import InstallationListList from "../pages/Installation-List/InstallationList";
import InstallationApprovalList from "../pages/Installation-Approval/InstallationApprovalList";
import InstallationApprovalView from "../pages/Installation-Approval/InstallationApprovalView";
import CommissioningListView from "../pages/Commissioning-List/CommissiongView";
import CommissioningListList from "../pages/Commissioning-List/CommissioningList";
import RoleView from "../pages/Masters/Roles/RoleView";
import StateView from "../pages/Masters/States/StateView";
import CityView from "../pages/Masters/Cities/CityView";
import UOMView from "../pages/Masters/UOM/UOMView";
import CategoryView from "../pages/Masters/Categories/CategoryView";
import WarehouseView from "../pages/Masters/Warehouses/WarehouseView";
import MenuView from "../pages/Masters/Menu/MenuView";
import StageView from "../pages/Masters/Stages/StageView";
import ItemView from "../pages/Masters/Items/ItemView";
import BOMView from "../pages/Masters/Boms/BOMView";
import InstallationView from "../pages/Masters/Installations/InstallationView";
import CommissioningView from "../pages/Masters/Commissioning/CommissioningView";
import UserView from "../pages/Masters/Users/UserView";
import SubcontractorAndCustomerView from "../pages/Masters/Subcontractor&Customer/Subcontractor&CustomenrView";
import ProjectDetails from "../pages/Reports/DashboardReports/PojectDetails";
import WarehouseDetails from "../pages/Reports/DashboardReports/WarehouseDetails";
import AvailableStocks from "../pages/Reports/DashboardReports/AvailableStocks";
import CategoryWiseStocks from "../pages/Reports/DashboardReports/CategoryWiseStocks";
import InwardAndOutwardWiseStocks from "../pages/Reports/DashboardReports/InwardAndOutwardStocks";
import ShortageReport from "../pages/Reports/DashboardReports/ShortageReport";
import ProvisionReport from "../pages/Reports/DashboardReports/ProvisionReport";
import MRBReport from "../pages/Reports/DashboardReports/MRBReport";
import ScrapReport from "../pages/Reports/DashboardReports/ScrapReport";
import InstallationReport from "../pages/Reports/DashboardReports/InstallationReport";
import CommissioningReport from "../pages/Reports/DashboardReports/CommissioningReport";
import InstallationClaimList from "../pages/Installation-Claim/InstallationClaimList";
import InstallationClaimView from "../pages/Installation-Claim/InstallationClaimView";
import CommissioningClaimView from "../pages/Commissioning-Claim/CommissioningClaimView";
import CommissioningClaimList from "../pages/Commissioning-Claim/CommissioningClaimList";
import MRBApprovalList from "../pages/MRB-Approval/MRBApprovalList";
import MRBApprovalView from "../pages/MRB-Approval/MRBApprovalView";
import OrdertLogList from "../pages/Logs/Order/OrderLogList";
import OrderLogView from "../pages/Logs/Order/OrderLogView";
import InvoiceLogView from "../pages/Logs/Invoice/InvoiceLogView";
import InvoiceLogtList from "../pages/Logs/Invoice/InvoiceLogList";
import OutwardLogList from "../pages/Logs/Outward/OutwardLogList";
import OutwardLogView from "../pages/Logs/Outward/OutwardLogView";
import InstallationLogList from "../pages/Logs/Installation/InstallationLogList";
import InstallationLogView from "../pages/Logs/Installation/InstallationLogView";
import HistoryReport from "../pages/Reports/DashboardReports/HistoryReport";
import UserWiseReport from "../pages/Reports/DashboardReports/UserWiseReport";

const createRoute = (path, component) => ({ path, component });

const routes = [
  createRoute("/dashboard", <Dashboard />),
  createRoute("/role-list", <RoleList />),
  createRoute("/role-create/:id?", <RoleCreate />),
  createRoute("/role-view/:id?", <RoleView />),
  createRoute("/user-list", <UserList />),
  createRoute("/user-create/:id?", <UserCreate />),
  createRoute("/user-view/:id?", <UserView />),

  createRoute("/state-list", <StateList />),
  createRoute("/state-create/:id?", <StateCreate />),
  createRoute("/state-view/:id?", <StateView />),
  createRoute("/city-list", <CityList />),
  createRoute("/city-create/:id?", <CityCreate />),
  createRoute("/city-view/:id?", <CityView />),
  createRoute("/uom-list", <UOMList />),
  createRoute("/uom-create/:id?", <UOMCreate />),
  createRoute("/uom-view/:id?", <UOMView />),
  createRoute("/category-list", <CategoryList />),
  createRoute("/category-create/:id?", <CategoryCreate />),
  createRoute("/category-view/:id?", <CategoryView />),
  createRoute("/menu-list", <MenuList />),
  createRoute("/menu-create/:id?", <MenuCreate />),
  createRoute("/menu-view/:id?", <MenuView />),

  createRoute("/stage-create/:id?", <StageCreate />),
  createRoute("/stage-list", <StageList />),
  createRoute("/stage-view/:id?", <StageView />),

  createRoute("/gstpercentage-create/:id?", <GSTPercentageCreate />),
  createRoute("/gstpercentage-list", <GSTPercentageList />),
  createRoute("/warehouse-list", <WarehouseList />),
  createRoute("/warehouse-create/:id?", <WarehouseCreate />),
  createRoute("/warehouse-view/:id?", <WarehouseView />),

  createRoute("/item-list", <ItemList />),
  createRoute("/item-create/:id?", <ItemCreate />),
  createRoute("/item-view/:id?", <ItemView />),

  createRoute("/bom-list", <BOMList />),
  createRoute("/bom-create/:id?", <BOMCreate />),
  createRoute("/bom-view/:id?", <BOMView />),

  createRoute("/commissioning-create/:id?", <CommissioningCreate />),
  createRoute("/commissioning-list", <CommissioningList />),
  createRoute("/commissioning-view/:id?", <CommissioningView />),

  createRoute("/installation-create/:id?", <InstallationCreate />),
  createRoute("/installation-view/:id?", <InstallationView />),

  createRoute("/installation-list", <InstallationList />),

  //project
  createRoute("/project-list", <ProjectList />),
  createRoute("/project-create/:id?", <ProjectCreate />),
  createRoute("/project-view/:id?", <ProjectView />),

  //order
  createRoute("/order-list", <OrderList />),
  createRoute("/order-create/:id?", <OrderCreate />),
  createRoute("/order-view/:id?", <OrderView />),

  //invoice
  createRoute("/invoice-list", <InvoicetList />),
  createRoute("/invoice-create/:id?", <InvoiceCreate />),
  createRoute("/invoice-view/:id?", <InvoiceView />),

  //inward
  createRoute("/inward-list", <InwardList />),
  createRoute("/inward-create/:id?", <InwardCreate />),
  createRoute("/inward-view/:id?", <InwardView />),

  //return inward
  createRoute("/return-inward-list", <ReturnInwardList />),
  createRoute("/return-inward-create/:id?", <ReturnInwardCreate />),
  createRoute("/return-inward-view/:id?", <ReturnInwardView />),

  //outward
  createRoute("/outward-list", <OutwardList />),
  createRoute("/outward-create/:id?", <OutwardCreate />),
  createRoute("/outward-view/:id?", <OutwardView />),

  //scrab-Approval
  createRoute("/scrap-approval-list", <ScrabApprovalList />),
  createRoute("/scrap-approval-view/:id?", <ScrabApprovalView />),

  //mrb-Approval
  createRoute("/mrb-approval-list", <MRBApprovalList />),
  createRoute("/mrb-approval-view/:id?", <MRBApprovalView />),

  //installation-list
  createRoute("/installationlist-list", <InstallationListList />),
  createRoute("/installationlist-view/:id?", <InstallationListView />),

  //installation-approval-list
  createRoute("/installation-approval-list", <InstallationApprovalList />),
  createRoute("/installation-approval-view/:id?", <InstallationApprovalView />),

  //installation-Claim
  createRoute("/installation-claim-list", <InstallationClaimList />),
  createRoute("/installation-claim-view/:id?", <InstallationClaimView />),

  //commissioning-list
  createRoute("/commissioninglist-list", <CommissioningListList />),
  createRoute("/commissioninglist-view/:id?", <CommissioningListView />),

  //commissioning-claim
  createRoute("/commissioning-claim-list", <CommissioningClaimList />),
  createRoute("/commissioning-claim-view/:id?", <CommissioningClaimView />),

  //outward
  createRoute("/subcontractor-customer-list", <SubcontractorAndCustomerList />),
  createRoute(
    "/subcontractor-customer-create/:id?",
    <SubcontractorAndCustomerCreate />
  ),
  createRoute(
    "/subcontractor-customer-view/:id?",
    <SubcontractorAndCustomerView />
  ),

  //reports
  createRoute("/view-stocks", <ViewStocks />),
  createRoute("/order-tracking", <OrderTracking />),
  createRoute("/project-details", <ProjectDetails />),
  createRoute("/warehouse-details", <WarehouseDetails />),
  createRoute("/available-stocks", <AvailableStocks />),
  createRoute("/category-wise-stocks", <CategoryWiseStocks />),
  createRoute("/inward-outward-wise-stocks", <InwardAndOutwardWiseStocks />),
  createRoute("/shortage-report", <ShortageReport />),
  createRoute("/provision-report", <ProvisionReport />),
  createRoute("/mrb-report", <MRBReport />),
  createRoute("/scrap-report", <ScrapReport />),
  createRoute("/installation-report", <InstallationReport />),
  createRoute("/commissioning-report", <CommissioningReport />),
  createRoute("/history-report", <HistoryReport/>),
  createRoute("/userwise-report", <UserWiseReport/>),

  // Access routes
  createRoute("/project-access/:id?", <ProjectAccess />),
  createRoute("/user-type-access/:id?", <UserTypeAccess />),
  createRoute("/user-menu-access/:id?", <UserMenuAccess />),

  //Logs routes

  createRoute("/order-log-list", <OrdertLogList />),
  createRoute("/order-log-view/:id?", <OrderLogView />),
  createRoute("/invoice-log-list", <InvoiceLogtList />),
  createRoute("/invoice-log-view/:id?", <InvoiceLogView />),
  createRoute("/outward-log-list", <OutwardLogList />),
  createRoute("/outward-log-view/:id?", <OutwardLogView />),
  createRoute("/installation-log-list", <InstallationLogList />),
  createRoute("/installation-log-view/:id?", <InstallationLogView />),

  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
];

const paginationRoute = routes
  .filter((route) =>
    [
      "/role-list",
      "/user-list",
      "/state-list",
      "/city-list",
      "/uom-list",
      "/category-list",
      "/warehouse-list",
      "/menu-list",
      "/item-list",
      "/bom-list",
      "/project-list",
      "/order-list",
      "/invoice-list",
      "/inward-list",
      "/outward-list",
      "/scrap-approval-list",
      "/mrb-approval-list",
      "/installationlist-list",
      "/commissioninglist-list",
      "/installation-approval-list",
      "/installation-list",
      "/commissioning-list",
      "/stage-list",
      "/gstpercentage-list",
      "/subcontractor-customer-list",
      "/installation-claim-list",
      "/commissioning-claim-list",
      "/installation-log-list",
      "/outward-log-list",
      "/invoice-log-list",
      "/order-log-list",
      "/return-inward-list",
    ].includes(route.path)
  )
  .map((route) => route.path);

export { routes, paginationRoute };
